import { Component, input } from '@angular/core';
import { TextInputComponent, textInputImports } from './text-input.component';

@Component({
    selector: 'app-web-input',
    templateUrl: 'text-input.component.html',
    imports: [textInputImports],
})
/**
 * @Deprecated("use signal based v2")
 */
export class WebInputComponent extends TextInputComponent {
    public override id = input<string, string | number>('web', { transform: v => String(v) });

    public override icon = input<string | null>('pi-globe');
}
